import { createAction } from 'redux-actions';

export const onChangeQuery = createAction('OUTREACH_ON_CHANGE_QUERY');

export const onClearQuery = createAction('OUTREACH_ON_CLEAR_QUERY');
